<script>
export default {
  name: "AboutV"
}
</script>

<template>
<div align="center">
  <h1 style="max-width: 75%;padding-top: 80px">A Partnership Built on Precision and Impact</h1>
  <h1 style="max-width: 75%">More Than a Box</h1>
  <b-card-sub-title style="font-size: x-large;padding-top: 20px;max-width: 75%">At XIYUE, we believe packaging is the silent ambassador of your brand. It speaks before your product is touched, and it lingers long after the unboxing. Founded with a vision to bridge exceptionalcraftsmanship with strategic brand storytelling, we have grown into a trusted partner for businesses that refuse to compromise on quality, sustainability, or presence.</b-card-sub-title>
  <b-card-group deck  style="max-width: 75%;padding-top: 30px">
    <b-card bg-variant="success" text-variant="white" header="Our Why" class="text-center">
      <b-card-text class="text-left">In a world of fleeting impressions, we create lasting ones. We understand that packaging is not just a container—it’s the first physical touchpoint between your brand and your customer. That moment deserves intention, innovation, and impeccable execution.</b-card-text>
    </b-card>
    <b-card bg-variant="success" text-variant="white" header="Our How" class="text-center">
      <b-card-text class="text-left">We combine engineered precision with creative vision. From structural design to material selection, every project is guided by a relentless focus on:</b-card-text>
      <ul class="text-left">
        <li>Shelf Impact – Making your product stop the eye and inspire the hand.</li>
        <li>Functional Intelligence – Ensuring protection, usability, and sustainability.</li>
        <li>Seamless Process – Delivering end-to-end solutions, from concept to delivery, with clarity and reliability.</li>
      </ul>
    </b-card>
    <b-card bg-variant="success" text-variant="white" header="Our Promise" class="text-center">
      <b-card-text class="text-left">We don’t just manufacture packaging. We craft brand experiences. Whether you’re launching a luxury product, optimizing an e-commerce shipment, or redesigning your retail presence, we provide the expertise, attention, and agility to bring your vision to life—on time, on budget, and beyond expectation.</b-card-text>
    </b-card>
  </b-card-group>
</div>
</template>

<style scoped lang="scss">

</style>